module.exports = __webpack_public_path__ + "static/media/h.d0e33e88.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/h.mp3
// module id = 97
// module chunks = 0